import data from 'constants/data';
import { SET_RESULT } from 'state/actions/questionnaireActions';

const initialQuestionnaireState = {
  questions: Object.assign({}, data.questions),
  results: {}
};

export default function questionnaireState(state = initialQuestionnaireState, action) {
  switch (action.type) {
    case SET_RESULT:
      /* This gnarly code just checks if the question group is discrete,
       * and sets all other results for the group to false when setting
       * one to true. Would be way easier in Ember tho sorry haters
       */
      let questionGroup = Object.keys(state.questions).map(key => state.questions[key]).find(q => {
        return Object.keys(q.items).map(k => k).find(id => id === action.payload.q.id);
      });
      if (questionGroup.type === 'discrete' && !!action.payload.item) {
        let falsify = {};
        Object.keys(questionGroup.items).filter(id => action.payload.q.id !== id).forEach(id => {
          falsify[id] = undefined
        });
        return {
          ...state,
          results: {
            ...state.results,
            ...falsify,
            [action.payload.q.id]: action.payload.item
          }
        }
      }

      return { ...state, results: {...state.results, [action.payload.q.id]: action.payload.item } }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/questionnaireReducer.js